<template>
  <div class="container container-fluid">
    <div v-if="showComponentData">
      <div class="row">
        <!-- CHECK GNC -->
        <div v-if="isFieldVisible('gnc_installed')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="gnc_installed" class="form-label text-left">{{ getFieldDescription('gnc_installed') }}</label>
            <div class="form-check form-switch">
              <input
                type="checkbox"
                class="form-check-input"
                v-model="formData.gnc_installed"
                @change="emitFieldChanged(gnc_installed)"
              />
              <label class="form-check-label"></label>
            </div>
          </div>
        </div>
        <!--MARCA GNC -->
        <div v-if="formData.gnc_installed && isFieldVisible('gnc_brand')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="gnc_brand" class="form-label text-left">Marca</label>
            <input
              type="text"
              class="form-control"
              name="gnc_brand"
              required="required"
              v-model="formData.gnc_brand"
              maxlength="191"
              @input="() => emitFieldChanged('gnc_brand')"
            />
          </div>
        </div>
        <!-- VOLUMEN M3 GNC -->
        <div v-if="formData.gnc_installed && isFieldVisible('gnc_volume_m3')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="gnc_volume_m3" class="form-label text-left">Capacidad del tanque (m3)</label>
            <input
              type="text"
              class="form-control"
              name="gnc_volume_m3"
              v-model="formData.gnc_volume_m3"
              maxlength="8"
              required="required"
              @input="() => emitFieldChanged('gnc_volume_m3')"
            />
          </div>
        </div>
        <!-- VEHCA DE VENCIMIENTO GNC -->
        <div v-if="formData.gnc_installed && isFieldVisible('gnc_due_date_formatted')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="gnc_due_date_formatted" class="form-label text-left">Fecha vencimiento</label>
            <input
              type="date"
              class="form-control"
              name="gnc_due_date"
              v-model="formData.gnc_due_date"
              required="required"
              @input="() => emitFieldChanged('gnc_due_date')"
            />
          </div>
        </div>
      </div>
      <hr class="custom-hr mt-4" />
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  name: 'FormGNC',
  props: {
    data: Object,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);

    const formData = ref({
      gnc_installed: false,
      gnc_brand: null,
      gnc_volume_m3: null,
      gnc_due_date: null,
    });

    const cargarDatos = () => {
      try {
        showComponentData.value = (dataCompany.value && dataCompany.value.gnc_installed );
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const emitFieldChanged = () => {
      const newFormData = { ...formData.value };
      const gncInstalledValue = formData.value.gnc_installed ? 1 : 0;

      if (newFormData.gnc_due_date) {
        // Asegurarse de que esté en formato YYYY-MM-DD (string)
        const d = new Date(newFormData.gnc_due_date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        newFormData.gnc_due_date = `${year}-${month}-${day}`; // formato ISO fecha sin hora
        console.log(newFormData.gnc_due_date)
      }

      emit('formDataChanged', { ...newFormData, gnc_installed: gncInstalledValue });
    };

    onMounted(cargarDatos);

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      formData,
      emitFieldChanged,
    };
  },
};
</script>
